module.exports = __webpack_public_path__ + "static/media/means_of_escape.5a151117.svg";